import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { Giftcards } from '@df/module-giftcards/giftcards';
import { GiftcardsProductViewComponentDef } from '@df/module-giftcards/giftcards-product-view.component.def';
import { ImageModule } from '@df/module-image/image.module';
import { LoqateEmailValidateDirective } from '@df/module-loqate/email/loqate-email.validator';
import { OnChange } from '@df/ng/on-change';
import { optionLabelPipe } from '@df/ui/common/option-label.pipe';
import { DfUiModule } from '@df/ui/df-ui.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsOutletBlockComponent } from '../../catalog/outlet-block/icms-outlet-block.component';
import { CalendarComponent } from '../../ui/form/calendar/calendar.component';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { GiftcardsAddToBasketComponent } from './giftcards-add-to-basket.component';
import { GiftcardsAmountSelectorComponent } from './giftcards-amount-selector.component';
import { GiftcardsProductConfigurableOptionsComponent } from './giftcards-product-configurable-options.component';
import { MatchCheckDirective } from '@df/ui/form/match-check.directive';
const datePipe = new DatePipe('en-GB');
export const personaliseOccasion = 'Personalise';

declare module '@df/module-giftcards/giftcards' {
    namespace Giftcards {
        interface ISelectionContainer {
            file?: string | ArrayBuffer;
        }
    }
}
@Component({
    selector: 'giftcards-product-view',
    templateUrl: './giftcards-product-view.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./giftcards-product-view.scss'],
    standalone: true,
    imports: [
        CalendarComponent,
        DatePipe,
        DfUiModule,
        FormsModule,
        GiftcardsAddToBasketComponent,
        GiftcardsAmountSelectorComponent,
        GiftcardsProductConfigurableOptionsComponent,
        ImageModule,
        InputWrapComponent,
        InputWrapBodyDirective,
        LoqateEmailValidateDirective,
        MatchCheckDirective,
        MuiInputDirective,
        NgClass,
        ICmsOutletBlockComponent,
        TranslationModule
    ]
})
export class GiftcardsProductViewComponent extends GiftcardsProductViewComponentDef {
    /**
     * Recipient type enum
     */
    readonly ERecipientType = Giftcards.ERecipientType;
    protected override canDetach = false;
    @OnChange(function () {
        if (this.initiated) {
            this.detectChanges();
        }
    })
    protected recipient_email_confirmation?: string;
    protected customImageSrc?: string | ArrayBuffer;
    readonly openPersonaliseEmmiter = new EventEmitter<void>();

    sendGiftCardImmediately?: boolean = true;
    defaultDeliveryDate?: string;

    override ngOnInit() {
        super.ngOnInit();
        this.request.recipientType = this.ERecipientType.recipient;
        this.defaultDeliveryDate = this.getDefaultDeliveryDate();
        this.calendarOptions.min = new Date(new Date(new Date().setHours(0, 0, 0, 0)).setDate(new Date().getDate() + 1));
        this.calendarOptions.displayOtherMonthsDates = true;
    }

    get stickyOff(): boolean {
        return this.app.client.isS;
    }
    get showEmailForm(): boolean {
        return this.request.recipientType === this.ERecipientType.recipient;
    }

    get canDisplayCustomImage(): boolean {
        return !!this.customImageSrc && !!this.request.file;
    }

    get isPersonalisePlaceholder(): boolean {
        return this.isPersonaliseOccasionSelected && !this.canDisplayCustomImage;
    }

    /*
     * returns default delivery date (the next day)
     */
    protected getDefaultDeliveryDate() {
        const date = new Date();
        return datePipe.transform(date.setDate(new Date().getDate() + 1), 'MM/dd/yyyy');
    }

    protected toggleDeliveryDateType(immediately: boolean): void {
        this.sendGiftCardImmediately = immediately;
        this.request.am_giftcard_date_delivery = immediately ? undefined : this.defaultDeliveryDate;
        this.detectChanges();
    }
    /**
     * Set recipuent type
     */
    protected setRecipientType(recipientType: Giftcards.ERecipientType): void {
        if (this.request.recipientType !== recipientType) {
            this.request.recipientType = recipientType;
            this.detectChanges();
        }
    }

    protected onSuccess(): void {
        this.updateCustomImage(true);
        this.detectChanges();
    }

    protected clickOnGallery(): void {
        if (this.isPersonalisePlaceholder) {
            this.openPersonaliseEmmiter.emit();
        }
    }

    // Used in giftcard custom options

    get isPersonaliseOccasionSelected(): boolean {
        return optionLabelPipe(this.model.data?.giftcard_occasion, 'giftcard_occasion') === personaliseOccasion;
    }

    public updateCustomImage(removeFile = false): void {
        if (!removeFile && this.request.file) {
            this.customImageSrc = this.request.file;
            this.detectChanges();
        } else {
            this.customImageSrc = undefined;
            this.request.file = undefined;
            this.request.am_giftcard_image = undefined;
        }
    }
}
